export const fields = ['gps', 'rfid', 'passcode'];
